"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = function (props) {
  return _react2["default"].createElement(
    "div",
    { style: props.styles.githubFooter },
    _react2["default"].createElement(
      "p",
      { style: props.styles.githubFooterP },
      "Public Activity"
    ),
    _react2["default"].createElement(
      "a",
      { style: props.styles.githubFooterA, href: "https://github.com/piotrromanowski/react-github-activity" },
      "GitHub Activity Feed"
    )
  );
};

module.exports = exports["default"];